import ProjectAsset from '~/models/ProjectData/ProjectAsset'

/**
 * @memberOf ProjectData
 * @extends ProjectData.ProjectAsset
 *
 */

class ProjectTransitionAsset extends ProjectAsset {

  // eslint-disable-next-line no-unused-vars
  constructor(jsonData, version) {
    super(jsonData)

    const {
      leftVideoAssetId,
      rightVideoAssetId,
      insertType,
      rightAssetMountingValues,
      leftAssetMountingValues,
      mountType = null,
    } = jsonData

    this._leftVideoAssetId = leftVideoAssetId
    this._rightVideoAssetId = rightVideoAssetId
    this._insertType = insertType
    this._rightAssetMountingValues = rightAssetMountingValues
    this._leftAssetMountingValues = leftAssetMountingValues
    this._mountType = mountType
  }

  /**
  * @returns {string}
  */
  get leftVideoAssetId() {
    return this._leftVideoAssetId
  }

  /**
   * @returns {string}
   */
  get rightVideoAssetId() {
    return this._rightVideoAssetId
  }

  /**
  * @returns {string}
  */
  get mountType() {
    return this._mountType
  }

  set mountType(mountType) {
    this._mountType = mountType
  }

}

export default ProjectTransitionAsset
